import { PoliticasDuraService } from './../../_services/politicas-dura.service';
import { PoliticaDura } from './../../_models/politica-duras';
import { Funcionalidad } from './../../_models/funcionalidad';
import { NavService } from './../../_services/_nav.service';
import { AutenticacionService } from './../../_services/autenticacion.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-politicas-duras-listado',
  templateUrl: './politicas-duras-listado.component.html',
  styleUrls: ['./politicas-duras-listado.component.css'],
})
export class PoliticasDurasListadoComponent implements OnInit {
  politicasDuras: PoliticaDura[] = [];
  carPoliticasDuras = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private router: Router,
    private polDuraServicio: PoliticasDuraService,
  ) {}
  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial() {
    const mn = this.autServicio
    .obtenerFuncionalidades()
    .find((x) => x.ruta === 'apl/politicas-duras');
  if (mn) {
    this.menu = mn;
  }

  this.columnas = [
    {
      field: 'tipoPoliticaDura',
      header: this.navServicio.buscarMensaje('POLITICASDURAS.LBL_POLITICAS'),
      sort: false,
    },
    {
      field: 'parametro',
      header: this.navServicio.buscarMensaje('POLITICASDURAS.LBL_PARAMETROS'),
      sort: true,
    },
    {
      field: 'indicadorHabilitado',
      header: this.navServicio.buscarMensaje('LBL_HABILITADO'),
      sort: false,
    },
    {
      field: 'det',
      header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
      sort: false,
    }
  ];
  this.busqueda = this.navServicio.getSearch('politicas-duras-listado.component');

  this.polDuraServicio.listadoHabilitados().subscribe((politicaasDuras) => {
    this.politicasDuras = politicaasDuras;
    this.politicasDuras.forEach((x) => {
      x.parametro = x.parametro ? x.parametro : x.tipoDocumento ? x.tipoDocumento : x.camino ? x.camino : null;
    });
    this.carPoliticasDuras = false;
    this.tabla.filterGlobal(this.busqueda, 'contains');
  });
  }

  crearPoliticaDura() {
    this.router.navigate(['apl/politicas-duras/agregar']);
  }

  verPoliticaDura(politicaDura: PoliticaDura) {
    this.router.navigate(['apl/politicas-duras/detalle/' + politicaDura.idPoliticaDura]);
  }

  editarPoliticaDura(politicaDura: PoliticaDura) {
    this.router.navigate(['apl/politicas-duras/actualizar/' + politicaDura.idPoliticaDura]);
  }

  eliminarPoliticaDura(politicaDura: PoliticaDura) {
    this.carPoliticasDuras = true;
    politicaDura.indicadorHabilitado = false;
    this.polDuraServicio.actualizar(politicaDura).subscribe(
      (res) => {
        this.autServicio.sendNotificationPoliticaDura(politicaDura.idPoliticaDura ).toPromise();
        this.navServicio.setMesage(1);
        this.cargaInicial();
      },
      (error) => {
        this.navServicio.setMesage(3);
      }
    );
  }

  setBusqueda() {
    this.navServicio.setSearch('politicas-duras-listado.component', this.busqueda);
  }
}
